


















import container from '@/model/ModelContainer';
import { MultipleDeletionOption } from '@/model/state/recorded/IRecordedState';
import ISnackbarState from '@/model/state/snackbar/ISnackbarState';
import Util from '@/util/Util';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

interface SelectItem {
    text: string;
    value: MultipleDeletionOption;
}

@Component({})
export default class RecordedMultipleDeletionDialog extends Vue {
    @Prop({ required: true })
    public isOpen!: boolean;

    @Prop({ required: true })
    public total!: number;

    @Prop({ required: false })
    public disableOption: boolean | undefined;

    public isRemove: boolean = false;

    public optionItems: SelectItem[] = [];
    public deleteOption: MultipleDeletionOption = 'All';

    private snackbarState = container.get<ISnackbarState>('ISnackbarState');

    constructor() {
        super();

        this.optionItems.push({
            text: '全て',
            value: 'All',
        });
        this.optionItems.push({
            text: 'オリジナルファイルだけ',
            value: 'OnlyOriginalFile',
        });
        this.optionItems.push({
            text: 'エンコードファイルだけ',
            value: 'OnlyEncodedFile',
        });
    }

    /**
     * Prop で受け取った isOpen を直接は書き換えられないので
     * getter, setter を用意する
     */
    get dialogModel(): boolean {
        return this.isOpen;
    }
    set dialogModel(value: boolean) {
        this.$emit('update:isOpen', value);
    }

    public deleteRecorded(): void {
        this.$emit('delete', this.deleteOption);
    }

    @Watch('isOpen', { immediate: true })
    public onChangeState(newState: boolean, oldState: boolean): void {
        if (newState === true && !!oldState === false) {
            if (this.total === 0) {
                this.dialogModel = false;
                this.snackbarState.open({
                    color: 'error',
                    text: '番組を選択してください。',
                });
            }
        } else if (newState === false && oldState === true) {
            // close
            this.$nextTick(async () => {
                await Util.sleep(100);
                // dialog close アニメーションが終わったら要素を削除する
                this.isRemove = true;
                this.$nextTick(() => {
                    this.isRemove = false;
                });
            });
        }
    }
}
